<div class="organization-details" *ngIf="details">
  <!-- ORGANIZATION INFO -->
  <section class="card">
    <div class="card-header">
      <div class="card-header-left">
        <lucide-angular name="building-2" [size]="20" class="card-icon card-icon-blue"></lucide-angular>
        <h3 class="header-title">{{ details.details.name }}</h3>
      </div>
    </div>

    <div class="card-content">
      <div class="two-field-row">
        <div class="field">
          <span class="label">{{ "administration.organization.address" | translate }}</span>
          <span class="value">{{ details.details.address }} {{ details.details.addressNb }}</span>
        </div>

        <div class="field">
          <span class="label">{{ "administration.organization.postalCode" | translate }}</span>
          <span class="value">{{ details.details.postalCode }} {{ details.details.location }}</span>
        </div>
      </div>

      <div class="two-field-row">
        <div class="field">
          <span class="label">{{ "administration.organization.country" | translate }}</span>
          <span class="value">{{ details.details.country }}</span>
        </div>

        <div class="field">
          <span class="label">{{ "administration.organizationDetails.createdAt" | translate }}</span>
          <span class="value">{{ details.details.createdAt | date: "dd/MM/yyyy" }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- MEMBERS -->
  <section class="card">
    <div class="card-header">
      <div class="card-header-left">
        <lucide-angular name="users" [size]="20" class="card-icon card-icon-green"></lucide-angular>
        <h3 class="header-title">{{ "administration.organizationDetails.members.title" | translate }}</h3>
      </div>
    </div>

    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>{{ "common.email" | translate }}</th>
            <th>{{ "common.role" | translate }}</th>
            <th>{{ "common.status" | translate }}</th>
            <th>{{ "administration.organizationDetails.members.createdAt" | translate }}</th>
            <th *ngIf="showMemberActions">{{ "common.actions" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let member of details.members">
            <td>{{ member.email }}</td>
            <td>{{ "administration.role." + member.roleName | translate }}</td>
            <td>
              <span class="badge" [ngClass]="'badge-' + member.status.toLowerCase()">
                {{ "administration.userStatus." + member.status | translate }}
              </span>
            </td>
            <td>{{ member.createdAt | date: "dd/MM/yyyy" }}</td>
            <td *ngIf="showMemberActions" class="actions-cell">
              <ng-container *ngIf="canManageMember(member)">
                <button
                  *ngIf="canChangeMemberRole"
                  class="icon-button"
                  type="button"
                  [attr.aria-label]="'button.changeRole' | translate"
                  [title]="'button.changeRole' | translate"
                  (click)="openChangeRoleDialog(member)"
                >
                  <lucide-angular name="user-pen" [size]="16"></lucide-angular>
                </button>

                <button
                  *ngIf="canRemoveMember"
                  class="icon-button icon-button-danger"
                  type="button"
                  [attr.aria-label]="'button.remove' | translate"
                  [title]="'button.remove' | translate"
                  (click)="openRemoveMemberDialog(member)"
                >
                  <lucide-angular name="user-minus" [size]="16"></lucide-angular>
                </button>
              </ng-container>
            </td>
          </tr>

          <tr *ngIf="details.members.length === 0">
            <td [attr.colspan]="showMemberActions ? 5 : 4" class="empty-row">
              {{ "administration.organizationDetails.members.noData" | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- INVITATIONS -->
  <section class="card">
    <div class="card-header">
      <div class="card-header-left">
        <lucide-angular name="mail" [size]="20" class="card-icon card-icon-blue"></lucide-angular>
        <h3 class="header-title">{{ "administration.organizationDetails.invitations.title" | translate }}</h3>
      </div>
    </div>

    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>{{ "common.email" | translate }}</th>
            <th>{{ "common.role" | translate }}</th>
            <th>{{ "common.status" | translate }}</th>
            <th>{{ "administration.organizationDetails.invitations.sentAt" | translate }}</th>
            <th>{{ "administration.organizationDetails.invitations.expiresAt" | translate }}</th>
            <th *ngIf="isCurrentOrganization && showInvitationActions">{{ "common.actions" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let invitation of details.invitations">
            <td>{{ invitation.email }}</td>
            <td>{{ "administration.role." + invitation.role | translate }}</td>
            <td>
              <span class="badge" [ngClass]="'badge-' + invitation.status.toLowerCase()">
                {{ "administration.invitationStatus." + invitation.status | translate }}
              </span>
            </td>
            <td>{{ invitation.createdAt | date: "dd/MM/yyyy" }}</td>
            <td>{{ invitation.expiresAt | date: "dd/MM/yyyy" }}</td>
            <td *ngIf="isCurrentOrganization && showInvitationActions" class="actions-cell">
              <button
                *ngIf="
                  canResendInvitation && (invitation.status === InvitationStatus.PENDING || invitation.status === InvitationStatus.EXPIRED)
                "
                class="icon-button"
                type="button"
                [attr.aria-label]="'button.resend' | translate"
                [title]="'button.resend' | translate"
                (click)="resendInvitation(invitation)"
              >
                <lucide-angular name="send" [size]="16"></lucide-angular>
              </button>

              <button
                *ngIf="canRevokeInvitation && invitation.status === InvitationStatus.PENDING"
                class="icon-button icon-button-danger"
                type="button"
                [attr.aria-label]="'button.revoke' | translate"
                [title]="'button.revoke' | translate"
                (click)="revokeInvitation(invitation)"
              >
                <lucide-angular name="ban" [size]="16"></lucide-angular>
              </button>
            </td>
          </tr>

          <tr *ngIf="details.invitations.length === 0">
            <td [attr.colspan]="isCurrentOrganization && showInvitationActions ? 6 : 5" class="empty-row">
              {{ "administration.organizationDetails.invitations.noData" | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
